import SegmentedControl from '../../../Form/src/jsx/SegmentedControl';
import Link from '../components/ui/Link';
import { getPaymentIntervalOptions } from './plan';

export const getHeaderContentByStep = ({ getLabel, onChangePlan, paymentInterval, plan, setPaymentInterval, step }) => {
	switch (step) {
		case 0:
			return plan.payment_interval !== '' ? (
				<span className="prc-plan__payment">{getLabel(`payment_only_${paymentInterval}`)}</span>
			) : (
				<SegmentedControl
					options={getPaymentIntervalOptions(getLabel)}
					value={paymentInterval}
					onChange={(value) => {
						setPaymentInterval(value);
					}}
					testIdPrefix="prc-"
				/>
			);

		default:
			return (
				<Link onClick={onChangePlan} small={true} testId="prc-link-change-plan">
					{getLabel('nav_prev_change_plan')}
				</Link>
			);
	}
};
